import { Component, OnInit } from '@angular/core';
import { DataService } from '../../data.service';
import { MatDialog, MatDialogRef } from '@angular/material';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {MAT_MOMENT_DATE_FORMATS, MomentDateAdapter} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MatDatepicker} from '@angular/material/datepicker';
import * as _moment from 'moment';
import { Moment} from 'moment';

//const moment = _rollupMoment || _moment;
import * as pdfMake from 'pdfmake/build/pdfmake.js';
import * as pdfFonts from 'pdfmake/build/vfs_fonts.js';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

export const MY_FORMATS = {
  parse: {
    dateInput: 'L', 
  },
  display: {
    //dateInput: 'L',
    dateInput: 'MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMM YYYY',
  },
};

@Component({
  selector: 'app-indicadores-sisc',
  templateUrl: './indicadores-sisc.component.html',
  styleUrls: ['./indicadores-sisc.component.css'],
  providers: [
    { provide: MatDialogRef,useValue: {} },
    {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
    {provide: MAT_DATE_LOCALE, useValue: "es-MX" },
  ] 
})

export class IndicadoresSISCComponent implements OnInit {
  errMsg:any;
  roles:any=[];
  prods:any=[];
  descs:any=[];
  cat:any=[];
  sisc2:any=[];
  totales:any=[];
  metas:any=[];
  loading:boolean=false;
  fecIni:any = _moment().startOf("month");
  fecFin:any = _moment().endOf("month");
  formato:any=[];
  formStyle:any[];
  elemImp:any[];
  elemStyle:any[]=[]; 
  idDestinatario:number; 
  destinatario:any=[];
  trimestre:boolean=false;
  jefe:any=[];
  diario:any=[];
  siscCat:any=[];
  dd:any;


  thisForm = new FormGroup({
    trimestre: new FormControl(this.trimestre, []),
  });
  
  constructor(private dataService: DataService) { }

  ngOnInit() {
    this.loading = true;
    this.totales.push({'numAct':null, 'asistencia':null});
    this.metas.push({'metaAct':null, 'metaAsis':null});
    this.dataService.getVars("REP-DES").subscribe(
                      rows => {   
                              this.idDestinatario = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnIdDestinatarioCargado());
    this.dataService.getJefe().subscribe(
                      rows => {   
                              this.jefe = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnJefeCargado());

    this.dataService.getFormatoImp(45, 1).subscribe(
                          rows => {   
                                  this.formato = <any>rows
                                  },          
                          error => this.errMsg = <any>error,
                          () => this.fnFormatoImpCargado());                      
    this.dataService.getCategorias().subscribe(
                      rows => {    
                              this.cat = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnCategoriasCargadas());
  }

  
  fnFormatoImpCargado(){
    //console.log("Formatos: ");
    //console.log(this.formato);
    var arrIdForms = [];
    for(var i = 0; i < this.formato.length; i++){
      arrIdForms.push(this.formato[i].id);
    }
    //--> Obtener styles
    this.dataService.getFormStyles(arrIdForms.join(","), "1,2").subscribe(
                rows => {   
                        this.formStyle = <any>rows
                        },          
                error => this.errMsg = <any>error,
                () => this.fnFormStyleCargado())
  }

  fnFormStyleCargado(){
    //console.log(this.formStyle)
    var arrStyles=[];
    for(var i = 0; i < this.formStyle.length; i++){
      arrStyles.push(this.formStyle[i].style);
    }
    arrStyles = arrStyles.filter(this.dataService.onlyUnique);        
    for(var i = 0; i < arrStyles.length; i++){
      this.elemStyle[arrStyles[i]] = {};
      for(var k = 0; k < this.formStyle.length; k++){
        if(arrStyles[i] == this.formStyle[k].style){
            var auxObj = Object.keys(this.elemStyle[arrStyles[i]]);
            //console.log("Keys of Object:");
            //console.log(auxObj);
            if(auxObj.length == 0)
              this.elemStyle[arrStyles[i]] = {[this.formStyle[k].key]:this.formStyle[k].valor} ;
            else
              this.elemStyle[arrStyles[i]][this.formStyle[k].key]   = this.formStyle[k].valor;
        }
      }
    }
    //console.log(this.elemStyle);
  }

  fnIdDestinatarioCargado(){
    //console.log(this.idDestinatario);
    this.dataService.getDestinatario(this.idDestinatario).subscribe(
                      rows => {   
                              this.destinatario = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnDestinatarioCargado());

  }

  fnDestinatarioCargado(){
    //console.log(this.destinatario);
  }

  fnJefeCargado(){
    //console.log(this.jefe);
  }

  fnCategoriasCargadas(){
    //console.log(this.cat);
    this.dataService.sisc2(1, this.fecIni.format("YYYYMMDD"), this.fecFin.format("YYYYMMDD"), false).subscribe(
                      rows => {   
                              this.siscCat = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnSISCxCategoriaCargado());    

    this.dataService.sisc2(1, this.fecIni.format("YYYYMMDD"), this.fecFin.format("YYYYMMDD"), true).subscribe(
                      rows => {   
                              this.sisc2 = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnSISCCargado());    
  }

  fnSISCxCategoriaCargado(){
    console.log(this.siscCat);
    for(var i = 0; i < this.siscCat.length; i++){
      if(this.siscCat[i].idGpo == 1)
        this.siscCat[i].etiqueta = this.siscCat[i].prod;
    }
  }

  fnSISCCargado(){
    console.log(this.sisc2);
    this.totales=[];
    this.totales.push({'numActs':null, 'numAdultos':null, 'numNinos':null, 'asistencia':null, 'total': 0});
    for(var x = 0; x < this.sisc2.length; x++){
      if (this.sisc2[x].acts == 1){
        if(this.sisc2[x].fechas.length > 0)
          this.sisc2[x].fecha = this.dataService.fnGetDateFormat(this.sisc2[x].fechas, "DMM")
      }
      else{
        var aux = this.sisc2[x].fechas.split(",");
        var mes = "";
        var res = "";
        for(var y = 0; y < aux.length; y++){
          if(y > 0 && mes != this.dataService.fnGetDateFormat(aux[y], "MM")){
            res += " de " + mes;
          }
          if(y > 0 && y < aux.length)
            res += ", ";
          mes = this.dataService.fnGetDateFormat(aux[y], "MM");
          res += this.dataService.fnGetDateFormat(aux[y], "D")
          if(y == aux.length - 1)
            res += " de " + mes;
        }
        this.sisc2[x].fecha = res;
      }
      this.totales[0].numActs += this.sisc2[x].acts;
      this.totales[0].numAdultos += this.sisc2[x].ver_adultos;
      this.totales[0].numNinos += this.sisc2[x].ver_ninos;
      this.totales[0].asistencia += this.sisc2[x].asis;
      this.totales[0].total += this.sisc2[x].total;
    }
    this.loading = false;
  }

  
  chosenMonthHandler(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>) {
    //console.log(this.fecIni);
    //console.log(normalizedMonth.format("YYYY/MM/DD"));
    this.fecIni = normalizedMonth;
    this.fecFin = _moment(this.fecIni).endOf("month");
    if(this.trimestre)
      this.fecFin = _moment(this.fecIni).add(2, "month").endOf("month");
    datepicker.close();
    this.dataService.sisc2(1, this.fecIni.format("YYYYMMDD"), this.fecFin.format("YYYYMMDD"), false).subscribe(
      rows => {   
              this.siscCat = <any>rows
              },          
      error => this.errMsg = <any>error,
      () => this.fnSISCxCategoriaCargado());  
    this.dataService.sisc2(1, this.fecIni.format("YYYYMMDD"), this.fecFin.format("YYYYMMDD"), true).subscribe(
                      rows => {   
                              this.sisc2 = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnSISCCargado());
  }

  chosenYearHandler(normalizedYear: Moment) {
    const ctrlValue = this.fecIni.value;
    ctrlValue.year(normalizedYear.year());
    this.fecIni.setValue(ctrlValue);
  }

  fnClickPeriodo(elem:any){
    setTimeout(() => {
      //console.log(elem);
      //console.log(this.thisForm.controls["trimestre"].value);
        if(this.thisForm.controls["trimestre"].value){
          this.trimestre = true;
          this.fecFin = _moment(this.fecIni).add(2, "month").endOf("month");

        }
        else{
          this.trimestre = false;
          this.fecFin = _moment(this.fecIni).endOf("month");
        }
        this.dataService.getCategorias().subscribe(
                      rows => {    
                              this.cat = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnCategoriasCargadas());
    }, 10);
  }

  fnImprimeReporte(idFormato){
    //console.log("Imprime Reporte");
    this.dataService.insLog(45,'IMPRIMIR', "SISC TAQUILLA",'').subscribe(
                            row => { var l = <any>row; }, error => this.errMsg = <any>error, () => "" );          
    this.dataService.getElemFormatoImp(idFormato, "'CONTENT', 'COLUMN', 'CELL', 'NEW_LINE', 'NEW_ROW', 'STYLE', 'POSITION', 'LINE', 'RECT', 'ELLIPSE', 'END DRAW', 'IMAGE', 'GRAF1', 'GRAF2', 'GRAF3', 'GRAF4'", "1,2").subscribe(
                            rows => {   
                                    this.elemImp = <any>rows
                                    },          
                            error => this.errMsg = <any>error,
                            () => this.fnElementosImpresionCargados(idFormato));              
  }

  fnElementosImpresionCargados(idFormato){
    var index = this.formato.findIndex(x => x.id === idFormato);
    var margins =this.formato[index].pageMargins.split(",");
    var height = 1.0;
    height = this.formato[index].lineHeight;
    var text = [];
    var text2 = [];
    var canvas = [];
    var images = [];  
    
    var auxLogo = <HTMLImageElement>document.getElementById("imgRepLogo");
    auxLogo.src = "../../../assets/logoBlack.png";

    var auxColTit = ["","Actividad","SISC", "Adultos", "Niños", "Total"];
    var auxColId = ["grupo","etiqueta","acts", "ver_adultos", "ver_ninos", "asis"];
    var auxColumna=[];
    var strCol;
    var auxLen;
    var auxMonto;
    var auxNbsp;
    for(var c=0; c<auxColId.length; c++){
      strCol="";
      for(var r=0; r<this.siscCat.length; r++){
        auxNbsp = "$";
        auxMonto = "";
        if(this.siscCat[r][auxColId[c]]){
          if(c==0){
            if(this.siscCat[r]["descuento"])
              auxLen = this.siscCat[r][auxColId[c]] + '   (' + this.siscCat[r]["descuento"] + ')';
            else
              auxLen = this.siscCat[r][auxColId[c]];
          }
          else 
            auxLen = this.siscCat[r][auxColId[c]];
        }
        else
          auxLen = "";
        if(c == 1 && auxLen.length > 72){
          strCol += auxLen.substr(0,72) + "ƒ" + auxLen.substr(72) + "ƒ";
          continue;
        }

        strCol += auxLen + "ƒ ƒ";   //--> Row vacío (prepara para Totales)
      }        
      if(c == 0)
        strCol += " " + "ƒ" +  "‧                 GRAN TOTAL: "    //-->  Inserta un total multi columna 
      if(c == 2)
        strCol += " " + "ƒ" +this.totales[0].numActs    //-->  Inserta un total         
      if(c == 3){
        strCol += " " + "ƒ" +this.totales[0].numAdultos    //-->  Inserta un total         
      }
      if(c == 4){
        strCol += " " + "ƒ" +this.totales[0].numNinos    //-->  Inserta un total         
      }
      if(c == 5){
        strCol += " " + "ƒ" +this.totales[0].asistencia    //-->  Inserta un total         
      }
      auxColumna.push(strCol);
    }

    var arrSpecialStrings = [{
      'FECHAEMI': this.dataService.fnGetDateFormat(this.fecIni.format("YYYY-MM-DD"), "MMY"),
      'PERIODO': this.trimestre ? "TRIMESTRALES" : "MENSUALES",
      'FILTRO1': "",
      'COLTIT': auxColTit,
      'COL': auxColumna
      //'DESCUENTO': (this.idDesc > 0 ? '(' + this.dataService.findItemInObject(this.descs, this.idDesc, "id").descuento + ')' : '')
    }];
    var auxTxtMargen = [0,0,0,0];
    for(var i = 0; i < this.elemImp.length; i++){
      if(this.elemImp[i].tipo == "content"){
        if(this.elemImp[i].margin.indexOf(",") > 0)
          auxTxtMargen = this.elemImp[i].margin.split(",");
          auxTxtMargen = auxTxtMargen.map(function (x) {  
            return parseInt(x.toString(), 10); 
          }); 
        //console.log(auxTxtMargen);   --> NO FUNCIONAN MARGENES EN TEXTO
        text.push({
                    text: this.dataService.fnReplaceSpecialStrings(this.elemImp[i].dato, arrSpecialStrings),
                    style: this.elemImp[i].style,
                    margin: [0,0,0,0],
                    color: this.elemImp[i].color,
                    alignment: this.elemImp[i].alignment
                  });                  
      }
      if(this.elemImp[i].tipo == "position"){
        text2.push({
                    text: this.dataService.fnReplaceSpecialStrings(this.elemImp[i].dato, arrSpecialStrings),
                    style: this.elemImp[i].style,
                    color: this.elemImp[i].color,
                    alignment: this.elemImp[i].alignment,                              
                    absolutePosition: {x: parseInt(this.elemImp[i].margin.split(",")[0]), y: parseInt(this.elemImp[i].margin.split(",")[1])}
                  });                  
      }
      if(this.elemImp[i].tipo == 'image' && this.elemImp[i].dato == "ƒLOGO" ){
        images.push({
                    image:  this.dataService.fnGetBase64Image(auxLogo, auxLogo.naturalWidth, auxLogo.naturalHeight),
                    fit: [85, 30],
                    alignment: this.elemImp[i].alignment,
                    absolutePosition: {x: parseInt(this.elemImp[i].margin.split(",")[0]), y: parseInt(this.elemImp[i].margin.split(",")[1]) }
                   })
      }
      if(this.elemImp[i].tipo == 'line'){
          canvas.push({
                      type: 'line',
                      r: 0,
                      x1: parseInt(this.elemImp[i].margin.split(",")[0]),
                      y1: parseInt(this.elemImp[i].margin.split(",")[1]),
                      x2: parseInt(this.elemImp[i].margin.split(",")[2]),
                      y2: parseInt(this.elemImp[i].margin.split(",")[3]),
                      lineColor: this.elemImp[i].color,
                      lineWidth: this.elemImp[i].alignment                               
                    })
      }
      if(this.elemImp[i].tipo == 'rect'){
        canvas.push({
                    type: 'rect',
                    r: 5,
                    fillOpacity: this.elemImp[i].style == "white" ? 0.01 : 0.3,
                    color: this.elemImp[i].style,
                    x: parseInt(this.elemImp[i].margin.split(",")[0]),
                    y: parseInt(this.elemImp[i].margin.split(",")[1]),
                    w: parseInt(this.elemImp[i].margin.split(",")[2]),
                    h: parseInt(this.elemImp[i].margin.split(",")[3]),
                    lineColor: this.elemImp[i].color,
                    lineWidth: this.elemImp[i].alignment                               
                  })
      }
    }

    var styles = this.elemStyle;
    var stack = [];
    if (this.formato[index].tipo == "TABLA")
      stack[0] = text;
    else
      stack.push({text:text});
    stack[1] = text2;
    stack.push({canvas:canvas});
    this.dd = {
      //pageSize: this.formato[index].pageSize,
      pageSize: 'letter',
      pageOrientation: this.formato[index].pageOrientation,
      pageMargins: [parseInt(margins[0]), parseInt(margins[1]), parseInt(margins[2]), parseInt(margins[3])],
      content: [
        {
          lineHeight: 1.0,
          alignment: 'left',
          background: 'white',
          color: 'black',
          stack       
        }
        ,images   
      ],
      styles
    }
    //pdfMake.createPdf(this.dd).print();
    pdfMake.createPdf(this.dd).open();
  }


}
